<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Staff Attendance Requests">
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>

        <!--Filter header start -->
        <v-row>
          <v-col class="mt-2" cols="12" md="2">
            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
              :return-value.sync="date" transition="scale-transition" offset-y max-width="290px"
              min-width="auto">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field v-model="date" label="Month" prepend-icon="mdi-calendar" readonly
                  v-bind="attrs" v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date" type="month" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">
                  Cancel
                </v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(date);getAttendanceRequests()">
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" md="2">
            <label class="font-weight-medium body-2">
              Type
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--All--" name="sectionSelect"
              v-model="filter.type" required item-value="id" item-text="value" :items="typeOptions"
              v-on:change="getAttendanceRequests()">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="2">
            <label class="font-weight-medium body-2">
              Status
            </label>
            <v-autocomplete class="my-0 py-1" placeholder="--All--" name="sectionSelect"
              v-model="filter.status" required item-value="id" :items="publishedFilterOpt" key="id"
              item-text="value" v-on:change="getAttendanceRequests()">
            </v-autocomplete>
          </v-col>
          <v-col class="mt-2" md="3">
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="filter.search" v-on:keyup="searchHandler" append-icon="mdi-magnify"
              class="ml-auto mb-2" label="Search" hide-details single-line
              style="max-width:350px;" />
          </v-col>
          <v-col cols="12" md="3">
            <div class="inside mt-5">
              <v-btn elevation="1" color="success" @click="getAttendanceRequests()">
                <v-icon left>mdi-magnify</v-icon>Search
              </v-btn>
            </div>
          </v-col>

        </v-row>
        <!--Filter header end -->

        <!--Data table start -->
        <v-data-table :headers="headers" :items="attendanceData" disable-pagination
          hide-default-footer>

          <template v-slot:item.actions="{ item }">
            <!-- <v-btn v-if="!item.isPublish" color="success" class="px-2 ml-1 ma-1" min-width="0"
              v-on:click="()=>{$router.push({ name: 'editAudit', params: {id: item.id} })}" small>
              <v-icon small> mdi-pencil </v-icon>
            </v-btn> -->
            <v-btn v-if="item.type==='Attendance' || item.type==='attendance'" color="success"
              class="px-2 ml-1 ma-1" min-width="0" small
              v-on:click="()=>{$router.push({ name: 'attendanceView', params: {id: item.id} })}">
              <v-icon small> mdi-eye </v-icon>
            </v-btn>
            <v-btn v-else color="success" class="px-2 ml-1 ma-1" min-width="0" small
              v-on:click="()=>{$router.push({ name: 'leaveView', params: {id: item.id} })}">
              <v-icon small> mdi-eye </v-icon>
            </v-btn>
            <!-- <v-btn color="success" v-else class="px-2 ml-1 ma-1" min-width="0" small>
              <v-icon small> mdi-reload </v-icon>
            </v-btn> -->
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <!--Data table end -->

        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange">
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
// import moment from 'moment'

export default {
  name: 'staffAttendance',
  components: { VCardComponent, MaterialCard },
  async created () {},
  mounted () {
    if (window.sessionStorage.getItem('teacherAttendance')) {
      let previousSelection = JSON.parse(window.sessionStorage.getItem('teacherAttendance'))
      console.log(previousSelection)
      // franchiseeID: this.franchisee.id,
      //     academicYearID: this.academicYear.id,
      //     page: this.page - 1,
      //     size: this.pageSize,
      //     type: this.filter.type,
      //     status: this.filter.status,
      //     search: this.filter.search,
      //     month: moment(this.date).month() + 1
      this.page = previousSelection.page + 1
      this.pageSize = previousSelection.pageSize
      this.filter.status = previousSelection.status
      this.filter.type = previousSelection.type
      this.filter.search = previousSelection.search
      this.date = new Date(moment().year(), previousSelection.month - 1, 3).toISOString().substr(0, 7)
    }
    this.getAttendanceRequests()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      console.log(val)
      this.franchiseeID = val.id
    },
    academicYear: async function (val) {
      console.log(val)
      this.academicYearID = val.id
    }
  },
  data () {
    return {
      filter: {
        type: '',
        status: '',
        search: ''
      },
      attendanceData: [],
      publishedFilterOpt: [
        {
          id: '',
          value: 'All'
        },
        {
          id: 'PENDING',
          value: 'PENDING'
        },
        {
          id: 'APPROVED',
          value: 'APPROVED'
        },
        {
          id: 'REJECTED',
          value: 'REJECTED'
        }
      ],
      isPublished: '',
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      typeOptions: [
        {
          id: '',
          value: 'All'
        },
        {
          id: 'Attendance',
          value: 'Attendance'
        },
        {
          id: 'Leave',
          value: 'Leave'
        }
      ],
      totalPages: 0,
      headers: [
        { text: 'Staff Name', value: 'Name', sortable: true },
        { text: 'Period', value: 'range', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Type', value: 'type', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ],
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false
    }
  },
  methods: {
    getAttendanceRequests: async function () {
      try {
        let requestParams = {
          franchiseeID: this.franchisee.id,
          academicYearID: this.academicYear.id,
          page: this.page - 1,
          size: this.pageSize,
          type: this.filter.type,
          status: this.filter.status,
          search: this.filter.search,
          month: moment(this.date).month() + 1
        }
        const { data } = await http.get(`${constants.API_URL}/api/attendanceModule/allattendanceleave`, {
          params: requestParams
        })
        window.sessionStorage.setItem('teacherAttendance', JSON.stringify(requestParams))
        this.totalPages = data.totalPages
        console.log(data)
        this.attendanceData = data.rows.map((item) => {
          item.Name = `${item.Name.user.firstName} ${item.Name.user.lastName}`
          item.range = `${item.fromDate} to ${item.toDate}`
          if (item.leaveDetails) {
            item.type = `${item.type} (${item.leaveDetails.name})`
          }
          return item
        })
      } catch (e) {
        console.log(e)
      }
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getAttendanceRequests()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getAttendanceRequests()
    },
    searchHandler: function (evt) {
      if (this.filter.search === '' || evt.key === 'Enter') {
        this.getAttendanceRequests()
      }
    }
  }
}
</script>

<style scoped>
</style>
